export default __webpack_public_path__ + "static/media/draw-7.cfcda523.jpg";